<template>
  <div class="employee-debtors-send-email-panel-building-form">
    <div class="employee-debtors-send-email-panel-building-form__row">
      <app-v-select :options="houses" select-label="address" label="Дом" placeholder="Выберите дом" searchable
                    v-model="house" :danger.sync="houseError" danger-text="Выберите дом"/>
    </div>

    <div class="employee-debtors-send-email-panel-building-form__row" v-if="house !== null">
      <app-v-select label="Список счетов"  :disabled="isFullBuilding" :danger.sync="listError" dangerText="Выберите лицевые счета" :options="apartments"  v-model="list" select-label="account_number" :reduce-function="option => option.account_number" :multiple="true" :loading="apartmentsLoading">
        <template slot="selected-option" slot-scope="option">
          <div style="display: flex; align-items: center;">
            {{ option.account_number }}
          </div>
        </template>
        <template slot="option" slot-scope="option">
          <div style="display: flex; align-items: center;">
            {{ option.account_number }}
          </div>
        </template>
        <template slot="no-options">
          Лицевые счета не найдены
        </template>
      </app-v-select>

      <div class="employee-debtors-send-email-panel-building-form__checkbox">
        <label class="employee-debtors-send-email-panel-building-form__checkbox-label">Отправить всему дому</label>
        <app-switch v-model="isFullBuilding" size="small"/>
      </div>


    </div>

    <div class="employee-debtors-send-email-panel-building-form__row">
      <app-input label="Тема письма" placeholder="Тема" v-model="name" :danger.sync="nameError"
                 danger-text="Введите тему письма"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BuildingForm",
    props: {
      buildingsId: {}
    },
    data() {
      return {
        name: null,
        nameError: false,
        houseError: false,
        list: [],
        apartments: [],
        apartmentsLoading: false,
        isFullBuilding: false,
        listError: false,
      }
    },
    computed: {
      house: {
        get(){
          return this.buildingsId;
        },
        set(v){
          this.$emit('update:buildingsId', v);
        }
      },
      houses() {
        return this.$store.getters['appUser/houses'];
      }
    },
    methods: {
      resetErrors() {
        this.houseError = false;
        this.nameError = false;
        this.listError = false;
      },
      checkErrors() {
        if (this.house === null) {
          this.houseError = true;
        }

        if (this.name === null || !this.name.trim().length) {
          this.nameError = true;
        }

        if (this.name === null || !this.name.trim().length) {
          this.nameError = true;
        }

        if(!this.isFullBuilding && !this.list.length){
          this.listError = true;
        }

        return this.houseError || this.nameError || this.listError;
      },
      getBody() {
        return {
          list: this.isFullBuilding ? null : this.list.join(','),
          name: this.name,
          buildings_id: this.house,
          who_id: this.$store.getters['appUser/id']
        }
      },
      async getApartments() {
        this.apartmentsLoading = true;
        this.list = [];
        try {
          let {data} = await this.$http.get(`all_aparts?buildings_id=${this.house}`);
          this.apartments = data.filter(apartment => apartment.account_number);
        } catch (e) {
          this.apartments = [];
        }
        finally {
          this.apartmentsLoading = false;
        }
      },
    },
    watch:{
      house(){
        if(this.house !== null){
          this.getApartments();
        }
        this.resetErrors();
      },
      isFullBuilding(){
        if(this.isFullBuilding){
          this.list = [];
        }
        this.listError = false;
      }
    }
  }
</script>

<style lang="scss">
  .employee-debtors-send-email-panel-building-form {
    width: 100%;

    &__row{
      margin-bottom: 15px;
    }

    &__checkbox{
      display: flex;
      align-items: center;
      margin-top: 5px;

      &-label{
        color: rgba(var(--app-heading-color-light), 1);
        font-size: 14px;
        margin-right: 10px;
        display: block;
      }
    }
  }
</style>
